import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { BankAccountDetails } from 'src/Components/BankAccounts/BankAccountDetails';
import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import useFetchBankAccount from 'src/Hooks/Queries/useFetchBankAccount';

const ViewBankAccountDrawer = () => {
  const { t } = useTranslation();
  const { bankAccountId } = useParams<{ bankAccountId: string }>();
  const { data: bankAccount } = useFetchBankAccount(bankAccountId);

  return (
    <AnimatedRoutedDrawer title={t('bankAccounts.details.title', 'Détails du compte')}>
      {({ onClose }) =>
        bankAccount && <BankAccountDetails bankAccount={bankAccount} onDelete={onClose} />
      }
    </AnimatedRoutedDrawer>
  );
};

export default ViewBankAccountDrawer;
